import { Routes, Route } from "react-router-dom";

import Login from "../pages/auth/Login";
import Dashboard from "../pages/dashboard/Dashboard";
import Layout from "../components/layout/Layout";
import Leads from "../pages/leads/Leads";
import Loans from "../pages/loans/Loans";
import Commission from "../pages/commission/Commission";
import CreateLead from "../pages/leads/CreateLead";

import ProtectedRoute from "../components/common/ProtectedRoute";
import Register from "../pages/auth/Register";
import ForgotPassword from "../pages/auth/ForgotPassword";
import LoanView from "../pages/loans/LoanView";
import Notifications from "../pages/notifications/Notifications";
import CreditList from "../pages/Creadit/CreditList";
import AddCredit from "../pages/Creadit/AddCredit";

// 🔥 DISBURSEMENT
import DisbursementList from "../pages/disbursement/DisbursementList";
import DisbursementForm from "../pages/disbursement/DisbursementForm";

// 🔥 COMMISSION FORM (NEW)
import AddCommission from "../pages/commission/AddCommission";

const AppRoutes = () => {
  return (
    <Routes>
      {/* 🔐 Auth */}
      <Route path="/" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />

      {/* 🔒 Protected */}
      <Route
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />

        {/* 🟣 LEADS */}
        <Route path="/leads" element={<Leads />} />
        <Route path="/leads/create" element={<CreateLead />} />
        <Route path="/leads/view/:id" element={<CreateLead />} />
        <Route path="/leads/edit/:id" element={<CreateLead />} />

        {/* 🟣 CREDIT */}
        <Route path="/credit" element={<CreditList />} />

        {/* CREATE CREDIT */}
        <Route path="/credit/create/:id" element={<AddCredit />} />

        {/* VIEW CREDIT */}
        <Route path="/credit/view/:id" element={<AddCredit />} />

        {/* 🟣 LOANS */}
        <Route path="/loans" element={<Loans />} />
        <Route path="/loans/view/:id" element={<LoanView />} />

        {/* 🟣 DISBURSEMENT */}
        <Route path="/disbursement" element={<DisbursementList />} />

        <Route path="/disbursement/create/:id" element={<DisbursementForm />} />

        <Route path="/disbursement/view/:id" element={<DisbursementForm />} />

        {/* 🟣 COMMISSION */}
        <Route path="/commission" element={<Commission />} />

        {/* CREATE / UPDATE */}
        <Route path="/commission/create/:id" element={<AddCommission />} />

        {/* VIEW */}
        <Route path="/commission/view/:id" element={<AddCommission />} />

        {/* 🟣 OTHER */}
        <Route path="/notifications" element={<Notifications />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
